import React from 'react';
import styles from './AppModal.module.css';
import { Modal, Grid, IconButton } from '@mui/material';
import { injectIntl } from 'react-intl';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import actions from './../../store/actions/index';
import { useSelector, useDispatch } from 'react-redux';
import Message from '../Message/Message';
import Button from '../UIElements/Button/Button';

const AppModal = (props) => {
    const dispatch = useDispatch();
    const { app } = useSelector(state => state);
    const modal = app.appModal;

    let modalContent = modal.content;
    let modalTitle = modal.title;
    let modalRoundedStyles = modal.rounded ? styles.Rounded : null;

    const ignoreResolution = (!!modal.toBeHidden);
    const screenResolutionClass = ignoreResolution ? styles.DesktopView : (app.mobileView ? styles.MobileView : styles.DesktopView);

    let errorMessage = "";
    if (modal.errorMessageId) {
        errorMessage += props.intl.formatMessage({ id: 'modal.error.' + modal.errorMessageId, defaultMessage: " " });
    }
    if (modal.errorMessageText) {
        errorMessage += props.intl.formatMessage({ id: 'modal.error.' + modal.errorMessageId, defaultMessage: " " });
    }

    if (!modal.content) {
        if (modal.type && (modal.messageId || modal.messageText)) {
            if (modal.type === "error") {
                modalTitle = props.intl.formatMessage({ id: 'modal.title.error' });
            }
            if (modal.type === "info") {
                //modalTitle = props.intl.formatMessage({ id: 'modal.title.info' });
            }
            modalContent = (
                <Message
                    type={modal.type}
                    labelId={modal.messageId}
                    text={modal.messageText}
                    data={modal.data}
                    onAccept={modal.acceptHandler}
                    onReject={modal.rejectHandler}
                    onFeedback={modal.feedbackHandler}
                    allowHTML={true}
                    customTextClass={modal.customTextClass}
                    hideConfirmationButtons={modal.hideConfirmationButtons}
                    iconToRender={modal.iconToRender}
                    customNoMsg={modal.customNoMsg}
                    childComponentToRender={modal.childComponentToRender}
                    consolidatedReport={modal.consolidatedReport}
                />
            )
        }
    }

    const handleClose = () => {
        dispatch(actions.app.setAppModal({ open: false, messageText:"" }));
        if (modal.closeHandler) {
            modal.closeHandler();
        }
    }

    const inlineStyles = {
        ...(modal.maxWidth) && { maxWidth: modal.maxWidth }
    }

    const getCloseIcon = () => {
        return(
            <div className={styles.InquiryModalClose}>
                <Button startIcon="close" role="icon" clickHandler={handleClose}/>
            </div>
        );
    }

    return (
        <Modal className={(!!modal.toBeHidden) ? styles.hide : ""} open={modal.open} disableRestoreFocus={true}>
            <div className={[styles.Wrapper, modalRoundedStyles, screenResolutionClass].join(" ")} style={inlineStyles}>
               {modal.type === "inquiry_modal" ? getCloseIcon() : null}
                <Grid container spacing={0} className={styles.ModalContent} style={modal.style || null}>
                    {
                        !app.appModal.hideHeader ?
                            <Grid size={{ xs: 12 }} className={styles.ModalHeader}>
                                <Header title={modalTitle} closeHandler={handleClose} />
                            </Grid> : null
                    }

                    <Grid size={{ xs: 12 }} className={styles.Body}>
                        <div className={styles.Content}>
                            {modalContent}
                        </div>
                    </Grid>
                    <Grid size={{ xs: 12 }} className={styles.Footer}>
                        <div className={styles.Content}>
                            <Footer
                                footerContent={modal.footerContent}
                                errorMessage={errorMessage.trim()}
                                showSpinner={modal.showSpinner}
                            />
                        </div>
                    </Grid>
                </Grid>
            </div>
        </Modal>
    );
}

export default (injectIntl(AppModal));